module.exports = __webpack_public_path__ + "static/media/Head To Toe Final Compressed Version m4v.4ac1a39d.mp4";